module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Howard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Richard Howard is the pseudonym of a bestselling British author who usually works in another genre. However, his love of the Napoleonic Wars, his life long interest in military history and particularly, the material offered by the campaigns of Napoleon drove him to write the series of novels featuring Alain Lausard and the men who fight alongside him.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/R7J6rn/tc-custom/9781788631976.jpg?1705012681044",
      "alt": "This image is the cover for the book Bonaparte's Invaders, The Alain Lausard Adventures"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bonaparte's Invaders, The Alain Lausard Adventures\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p'), _c('p', [_c('b', [_vm._v("Napoleon’s mighty army face the inferno of the Egyptian desert in this thrilling historical adventure, the sequel to "), _c('i', [_vm._v("Bonaparte’s Sons")]), _vm._v(".")])]), _c('p', [_c('i', [_vm._v("France, 1798. ")]), _vm._v("Seventeen thousand French troops leave Toulon harbor in May, unaware of their ultimate destination. Barely three months after taking Rome, Napoleon Bonaparte has rewarded his finest regiments with a place among the Army of the Orient, bound for Egypt. ")]), _c('p', [_vm._v(" Alain Lausard and his cavalry unit are on board the frigate "), _c('i', [_vm._v("L’Esperance")]), _vm._v(". Their first battle is merely to survive the degradation that is life at sea. By the time they stagger, starved and exhausted, upon the shores of Egypt, Lausard’s dragoons have more than glory to fight for. ")]), _vm._v(" As his beleaguered soldiers march into the desert, Bonaparte watches his tactical gamble collapse. Even when the Mameluke army is defeated beneath the pyramids, Admiral Nelson’s destruction of the French fleet and Bonaparte’s obsessive war-mongering convince Lausard that he will never see Paris again . . . \n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Books\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0